import { h, defineComponent, PropType } from 'vue';
import { coming_soon } from '@components/icons';
import { State } from '../../state';
import BarButton from '@components/bar-button';
import { toggle_axes } from '../../scene';
import toggle_axes_svg from '../../../assets/img/SVG_icons/Bottom/visualisation/toggle_axes.svg';
import { img } from '@phi/components';
import ToggleAxesTooltip from './ToggleAxesTooltip';

export const ToggleAxesIcon = toggle_axes_svg;

export default defineComponent({
    props: {
        state: {
            required: true,
            type: Object as PropType<State>,
        },
    },

    computed: {
        disabled() {
            return !this.state.loaded;
        },

        alt() {
            return 'Show coordinate axes and planes';
        },

        coming_soon() {
            return !this.state.loaded;
        },
    },

    methods: {
        onClick() {
            if (!this.disabled)
                toggle_axes();
        },
    },

    render() {
        return h(BarButton, {
            disabled: this.disabled,
            active: this.state.axes_visible,
            selected: this.state.tut_stage === 3,
            id: 'toggle-axes-button',
            tippy: 'top',
            onClick: this.onClick,
        }, {
            icon: () => this.coming_soon ? coming_soon(this.alt) : img(toggle_axes_svg, this.alt),
            tooltip: ToggleAxesTooltip,
        });
    }
});
